export default __webpack_public_path__ + "static/media/key.c82598df.svg";